var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeviceTablet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.15 5A2.85 2.85 0 0 1 7 2.15h10A2.85 2.85 0 0 1 19.85 5v14A2.85 2.85 0 0 1 17 21.85H7A2.85 2.85 0 0 1 4.15 19zM7 3.85A1.15 1.15 0 0 0 5.85 5v14c0 .635.515 1.15 1.15 1.15h10A1.15 1.15 0 0 0 18.15 19V5A1.15 1.15 0 0 0 17 3.85zM11.15 18c0-.47.38-.85.85-.85h.01a.85.85 0 0 1 0 1.7H12a.85.85 0 0 1-.85-.85",
  clipRule: "evenodd"
})));
export default SvgDeviceTablet;